import React from "react";

import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Button from "../../../components/Field/Button";
import Section from "../../../components/Section";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function LeftRightImageText({ left_right_image_text_items = [] }) {
    return (
        <Section className={style.LeftRightImageText}>
            <div className={style.leftRightImageTextWrap}>
                {
                    left_right_image_text_items.length > 0 && left_right_image_text_items.map((item, index) => {
                        return (
                            <div key={`leftRightImageTextItem_${index}`} className={style.leftRightImageTextItem}>
                                <div className={`${style.colRow} ${style[item.image_direction]}`}>
                                    <div className={`${style.col2}`}>
                                        <div className={style.colInner}>
                                            <div className={style.sectionRow}>
                                                {
                                                    item.title !== "" && (
                                                        <div className={style.sectionHeader}>
                                                            <Title tag="h3" className="fontTeko">{item.title}</Title>
                                                        </div>
                                                    )
                                                }
                                                {
                                                    item.text !== "" && (
                                                        <div className={style.sectionBody}>
                                                            <Editor text={item.text} />
                                                        </div>
                                                    )
                                                }
                                                {
                                                    item.button_label !== undefined && item.url !== undefined && item.button_label !== "" && item.url !== "" && (
                                                        <div className={style.sectionFooter}>
                                                            <Button
                                                                size="buttonBig"
                                                                color="buttonPrimaryWithOutBg"
                                                                link={item.url}
                                                                label={item.button_label}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${style.col2}`}>
                                        <div className={style.colInner}>
                                            <div className={style.imageWrap}>
                                                <Background src={item.image} size="1120x520" cPosition="topLeft" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </Section>
    )
}